import React from 'react';
import { useLocation } from 'react-router-dom';
import Star from '../components/star'; 
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import CustomerReview from '../components/customerReviews';
import '../app.css';
import FullPageLoader from '../components/FullPageLoader';
import supabase from '../supabase';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import finalemail from '../assets/finalmail.svg'
import finalphone from '../assets/finalphone.svg'
import finallocation from '../assets/finallocation.svg'
import finalfile from '../assets/finalfile.svg'
import finalinfo from '../assets/finalinfo.svg'
import finalcancel from '../assets/finalcancel.svg'
import defaultbusinessimg from '../assets/defaultBusiness.svg'
import ReviewSchema from '../components/reviewSchema';
import { useAuth } from '../context/AuthContext';
import { useMemo } from 'react';
import { Helmet } from "react-helmet-async";
import globeimg from '../assets/newglobe.svg'


export default function SelectedCompany({companyTitle, selectedLanguage, session}) {

  const { user } = useAuth(); 
  const currentUserId = user?.id;

  const [loading, setLoading] = useState(false);
  const [content, SetContent] = useState('');
  const [text, setText] = useState('');
  // Get today's date in YYYY-MM-DD format

  const [file, setFile] = useState(null);
// 1. Get Today
const todayObj = new Date();
const todayStr = todayObj.toISOString().split('T')[0]; 
const [privateNoteText, setprivateNoteText] = useState('');

// 2. Get 1 Year Ago
const yearAgoObj = new Date();
yearAgoObj.setFullYear(todayObj.getFullYear() - 1);
const yearAgoStr = yearAgoObj.toISOString().split('T')[0];

// 3. State (Default to today)
const [dateOfExperience, setDateOfExperience] = useState(todayStr);

// Helper: Converts file to clean Base64 string
  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]); 
    reader.onerror = (error) => reject(error);
  });

  
  
// ... existing state and imports
const [toast, setToast] = useState({ message: '', type: '' });

// 2. Add the helper function
const notify = (message, type = 'success') => {
  setToast({ message, type });
  setTimeout(() => setToast({ message: '', type: '' }), 4000);
};

const handleSubmit = async (e) => {
  e.preventDefault();

  // 1. Instant Guards (Silent & Clean)
  if (!user) return notify("Please log in to share your experience.", "error");
  if (!file) return notify("Proof of service is required for verification.", "error");
  if (!text.trim()) return notify("Please provide details in the review text.", "error");
  if (file.size > 4 * 1024 * 1024) return notify("File exceeds 4MB limit.", "error");

  setLoading(true);

  try {
    // 2. Parallel Execution
    const [ipResponse, base64String] = await Promise.all([
      fetch('https://api.ipify.org?format=json').then(res => res.json()),
      fileToBase64(file)
    ]);

    const { ip } = ipResponse;
    const fileExt = file.name.split('.').pop().toLowerCase();
    
    const authorName = `${user?.user_metadata?.name || ''} ${user?.user_metadata?.lastname || ''}`.trim() || 'Anonymous';

    // 3. Invoke Edge Function
    const { data, error: funcError } = await supabase.functions.invoke('process-regular-review', {
      body: {
        userIP: ip,
        userId: user.id,
        fileBase64: base64String,
        fileExtension: fileExt,
        reviewData: {
          stars: actualRating,
          title: content,
          text: text,
          company: www,
          author: authorName,
          category: cat,
          date: dateOfExperience
        },
        intelData: {
          content: privateNoteText,
        }
      }
    });

    if (funcError) throw funcError;

    // 4. Handle Response with Professional Messaging
    if (data?.success) {
      if (data.flagged) {
        notify("Submitted. Our team is auditing this review for authenticity.");
      } else {
        notify("Submitted. Our team is auditing this review for authenticity.");
      }
      
      // Cleanup
      setFile(null);
      setText('');
      SetContent('');
      setprivateNoteText('');
      setTimeout(() => setIsTestimonialWindowOpen(false), 2000); // Close slightly after toast appears
      
    } else {
      // Security-focused messaging
      notify(data?.message || "Submitted. Our team is auditing this review for authenticity.");
    }

  } catch (err) {
    console.error("SUBMISSION_FAIL:", err);
    notify("System Error: Unable to reach verification server.", "error");
  } finally {
    setLoading(false);
    setIsTestimonialWindowOpen(false)
  }
};

  
            const location = useLocation();
            const [allItemsData, setAllItemsData] = useState([]);
            const [isLoading, setIsLoading] = useState(false);
            const [error, setError] = useState(null);
            const [supabaseReviews, setSupabaseReviews] = useState([]);
            const [loadingDone, setLoadingDone] = useState(false);


            const pathname = location.pathname;
            const pathParts = pathname.split('/');
            const decodedLastPart = decodeURIComponent(pathParts[pathParts.length - 1]);




       const withWWW = decodedLastPart.startsWith('www.') 
  ? decodedLastPart 
  : `www.${decodedLastPart}`;

const withoutWWW = decodedLastPart.startsWith('www.') 
  ? decodedLastPart.replace('www.', '') 
  : decodedLastPart;

          
const currentItem = allItemsData.find(item => {
  if (!item.www) return false;

  try {
    // 1. Ensure the URL has a protocol so the URL constructor works
    const itemUrl = new URL(item.www.startsWith('http') ? item.www : `https://${item.www}`);
    
    // 2. Get the hostname and remove 'www.' from the front
    const itemHostname = itemUrl.hostname.toLowerCase().replace(/^www\./, '');
    
    // 3. Remove 'www.' from the search target as well
    const targetHostname = decodedLastPart.toLowerCase().replace(/^www\./, '');

    return itemHostname === targetHostname;
  } catch (e) {
    console.error("Invalid URL for item:", item.www);
    return false;
  }
});

                    var reviews = `${currentItem ? currentItem.reviews : '1'}`
const trustscore = currentItem ? Number(currentItem.trustscore) : 1.0;

                            



  var cat = `${currentItem ? currentItem.cat : ''}`
  var title = `${currentItem ? currentItem.title : 'blank'}`
  var img = `${currentItem ? currentItem.img : ''}`
  var www = `${currentItem ? currentItem.www : 'blank.com'}`
  var about = `${currentItem ? currentItem.about : ''}`
  var email = `${currentItem ? currentItem.email : ''}`
  var phone = `${currentItem ? currentItem.phone : ''}`
  var address = `${currentItem ? currentItem.address : ''}`
  var address1 = `${currentItem ? currentItem.address1 : ''}`
  var country = `${currentItem ? currentItem.country : ''}`
  var address2 = `${currentItem ? currentItem.address2 : ''}`
  var address3 = `${currentItem ? currentItem.address3 : ''}`
  var address4 =`${currentItem ? currentItem.address4 : ''}`
  var status = `${currentItem ? currentItem.status : ''}`


  const [isReviewLoading, setIsReviewLoading] = useState(false);

 useEffect(() => {
  const fetchCompanyAndReviews = async () => {
    // 0. INITIALIZE PRERENDER STATE
    // Tell the bot to wait until we are finished
    window.prerenderReady = false;

    // 1. Safety Guards
    if (!decodedLastPart || decodedLastPart === "categories") return;

    // 2. Clear previous states to avoid UI flickering
    setAllItemsData([]);
    setSupabaseReviews([]);
    setIsLoading(true);
    setIsReviewLoading(true);
    setError(null);

    try {
      // --- PHASE A: FETCH BUSINESS DATA ---
      const { data: bizData, error: bizError } = await supabase
        .from("businesses")
        .select("*")
        .or(`www.eq.${withoutWWW},www.eq.${withWWW}`)
        .maybeSingle();

      if (bizError) throw bizError;
      if (!bizData) {
        setError("Company not found");
        setIsLoading(false);
        // Even on error, we tell Prerender to stop waiting so it can index the 404/Error state
        window.prerenderReady = true; 
        return;
      }

      setAllItemsData([{
        ...bizData,
        cat: bizData.cat || bizData.category || "General",
        trustscore: parseFloat(bizData.trustscore || bizData.stars || 0),
        reviews: parseInt(bizData.reviews || 0),
        img: bizData.img || defaultbusinessimg,
        user_id: bizData.user_id || null,
        submission_type: bizData.submission_type || "regular"
      }]);
      setIsLoading(false); 

      // --- PHASE B: FETCH REVIEWS WITH JOIN ---
      const currentWWW = bizData.www;
      const { data: reviewsData, error: reviewsError } = await supabase
        .from("reviews")
        .select(`
          *,
          users!user_id (
            fullname,
            img,
            country
          )
        `)
        .eq("company", currentWWW)
        .eq('is_approved', true)
        .order('created_at', { ascending: false })
        .range(0, 60);

      if (reviewsError) throw reviewsError;

      if (reviewsData && reviewsData.length > 0) {
        const reviewIds = reviewsData.map(r => r.id);
        const userIds = [...new Set(reviewsData.map(r => r.user_id).filter(Boolean))];

        // --- PHASE C: PARALLEL BATCH FETCH ---
        const [countsRes, repliesRes, myLikesRes, totalLikesRes] = await Promise.all([
          userIds.length > 0 
            ? supabase.from("reviews").select("user_id").in("user_id", userIds).eq('is_approved', true)
            : Promise.resolve({ data: [] }),
          supabase.from("replies").select("*").in("review_id", reviewIds).order('created_at', { ascending: true }),
          currentUserId 
            ? supabase.from("likes").select("review_id").eq("user_id", currentUserId).in("review_id", reviewIds)
            : Promise.resolve({ data: [] }),
          supabase.from("likes").select("review_id").in("review_id", reviewIds)
        ]);

        // --- PHASE D: ORGANIZE DATA INTO MAPS ---
        const countMap = {};
        countsRes.data?.forEach(row => countMap[row.user_id] = (countMap[row.user_id] || 0) + 1);

        const repliesMap = {};
        repliesRes.data?.forEach(reply => {
          if (!repliesMap[reply.review_id]) repliesMap[reply.review_id] = [];
          repliesMap[reply.review_id].push(reply);
        });


        const myLikedSet = new Set(myLikesRes.data?.map(l => l.review_id));

        const totalLikesMap = {};
        totalLikesRes.data?.forEach(like => {
          totalLikesMap[like.review_id] = (totalLikesMap[like.review_id] || 0) + 1;
        });

        // --- PHASE E: ENRICH AND STATE UPDATE ---
        const enriched = reviewsData.map((r) => {
          const liveUser = r.users; 
          return {
            ...r,
            author: liveUser?.fullname || r.author || "Anonymous",
            img: liveUser?.img || r.img || null,
            countr: liveUser?.country || r.countr || "Unknown",
            otherrevs: countMap[r.user_id] || 0,
            replies: repliesMap[r.id] || [],
            userHasLiked: myLikedSet.has(r.id),
            userid: r.user_id,
            realLikeCount: totalLikesMap[r.id] || 0
          };
        });

        setSupabaseReviews(enriched);
      }
      setLoadingDone(true);

      // --- PHASE F: SUCCESS ---
      // Tell Prerender.io the page is fully loaded and ready for snapshot
      window.prerenderReady = true;

    } catch (err) {
      console.error("FATAL FETCH ERROR:", err.message);
      setError(err.message);
      // Tell Prerender to stop waiting even on failure
      window.prerenderReady = true; 
    } finally {
      setIsLoading(false);
      setIsReviewLoading(false);
    }
  };

  fetchCompanyAndReviews();
}, [decodedLastPart, withoutWWW, withWWW, currentUserId]);


  const modifiedwww = www?.replace(/^(https?:\/\/)?(www\.)?/, '');  

  const redirectToWeb = (www) => {
    setTimeout(() => {
      window.open(`https:www.${modifiedwww}`) 
    }, 300);
}
  let feedback

  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 10;
  const firstReviewRef = useRef(null);



  const smoothScrollTo = (element, duration, offset = 0) => {
    const start = window.scrollY;
    const target = element.getBoundingClientRect().top + window.scrollY - offset; 
    const distance = target - start;
    let startTime = null;
  
    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easing = progress * (2 - progress); 
      window.scrollTo(0, start + distance * easing);
  
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };
  
    requestAnimationFrame(animation);
  };
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (firstReviewRef.current) {
          smoothScrollTo(firstReviewRef.current, 1400, 100);
        }
      }, 0);
    });
  };

  

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };



  const customRound = (rating) => {
    const rounded = parseFloat(rating);
    if (isNaN(rounded)) return 0;
  
    const decimal = rounded % 1;
  
    if (decimal < 0.25) {
      return Math.floor(rounded);
    } else if (decimal < 0.75) {
      return Math.floor(rounded) + 0.5;
    } else {
      return Math.ceil(rounded);
    }
  };

  const getStarColor = (rounded) => {
    switch (true) {
      case rounded === 5:
        return 'bg-five';
      case rounded === 4.5:
        return 'bg-fourhalf';
      case rounded === 4:
        return 'bg-four';
      case rounded === 3.5:
        return 'bg-threehalf';
      case rounded === 3:
        return 'bg-three';
      case rounded === 2.5:
        return 'bg-twohalf';
      case rounded === 2:
        return 'bg-two';
      case rounded === 1.5:
        return 'bg-onehalf';
      case rounded === 1:
        return 'bg-one';
      default:
        return 'bg-gray-300';
    }
  };

  useEffect(() => {
    const onPopState = () => {
      if (window.location.pathname === '/somepage') {
        window.location.reload();
      }
    };

    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [location.pathname]);



useEffect(() => {
  const fetchAll = async () => {
    if (!decodedLastPart || decodedLastPart === "categories") return;

    // THE FIX: Resetting these two lines replaces the need for a reload
    setAllItemsData([]); 
    setSupabaseReviews([]); 
    
    setIsLoading(true);
    // ... rest of your fetch logic ...
  };
  fetchAll();
}, [decodedLastPart]);


  const toNumber = (value) => {
    if (typeof value === 'string') {
      return Number(value.replace(/,/g, ''));
    }
    return Number(value);
  };

  const originalReviews = toNumber(reviews) || 0; 
  const fetchedReviews = Array.isArray(supabaseReviews) ? supabaseReviews.length : 0;
  const fullReviews = originalReviews + fetchedReviews;


  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;

  const [selectedStarFilter, setSelectedStarFilter] = useState(null); // null means "show all"
const score = Number(trustscore) || 0;




const filteredAll = useMemo(() => {
  return supabaseReviews.filter(r => 
    selectedStarFilter === null || Number(r.stars) === Number(selectedStarFilter)
  );
}, [supabaseReviews, selectedStarFilter]);

// Then your pagination uses the filtered list instead of the full list
const currentReviews = useMemo(() => {
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  return filteredAll.slice(indexOfFirstReview, indexOfLastReview);
}, [filteredAll, currentPage]);

const totalPages = Math.ceil(filteredAll.length / reviewsPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);


  const fetchedStarSum = supabaseReviews.reduce((acc, review) => {
    return acc + (Number(review.stars || review.rating || 0));
  }, 0);


  let supabaseOnlyRating = fetchedStarSum / supabaseReviews.length


const [isTestimonialWindowOpen , setIsTestimonialWindowOpen] = useState(false);
const [actualRating, setActualRating] = useState(0);
const [hoverRating, setHoverRating] = useState(0);

const starIndexes = [1, 2, 3, 4, 5];

const handleStarClick = (index) => {
    setActualRating(index); // Store the selected rating
    setIsTestimonialWindowOpen(true); // Open the window
};

const getTestimonialStarColorz = (starIndex) => {
  // If we are hovering (hoverRating > 0) AND the current star index 
  // is less than or equal to the hoverRating, use the hover color.
  if (hoverRating > 0 && starIndex <= hoverRating) {
    // Return a specific color based on the final hover rating (e.g., 5-green, 3-yellow)
    switch (hoverRating) {
      case 5: return 'bg-five'; 
      case 4: return 'bg-four';
      case 3: return 'bg-three';
      case 2: return 'bg-two';
      case 1: return 'bg-one';
      default: return 'bg-[#E4E4E4] opacity-40';
    }
  }
  // Otherwise, use the default gray color
  return 'bg-[#E4E4E4] opacity-40';
};


const getWindowStarColor = (starIndex) => {
    if (starIndex <= actualRating) {
    switch (actualRating) {
      case 5: return 'bg-five'; 
      case 4: return 'bg-four';
      case 3: return 'bg-three';
      case 2: return 'bg-two';
      case 1: return 'bg-one';
      default: return 'bg-[#E4E4E4] opacity-40';
    }
    }
    // Otherwise, use the default gray color.
    return 'bg-[#E4E4E4] opacity-40';
};

useEffect(() => {
  setCurrentPage(1);


}, [selectedStarFilter]);

const [stableCategory, setStableCategory] = useState(null);

useEffect(() => {
  // Only update when 'cat' actually arrives from Supabase
  if (cat && cat.trim() !== "" && cat !== "null") {
    setStableCategory(cat);
  }
}, [cat]);

const getPaginationModel = () => {
  const delta = 1; // How many pages to show on each side of current page
  const range = [];
  const rangeWithDots = [];
  let l;

  range.push(1);
  for (let i = currentPage - delta; i <= currentPage + delta; i++) {
    if (i < totalPages && i > 1) {
      range.push(i);
    }
  }
  if (totalPages > 1) range.push(totalPages);

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }
  return rangeWithDots;
};

const smartPages = getPaginationModel();

const fiveStarPercent = score < 5.0 ? Math.round(Math.max(0, (score - 3.5) / 1.5) * 100) : 100;

const fourStarPercent = 100 - fiveStarPercent;


const getDistribution = (reviews) => {
  const total = reviews.length;
  if (total === 0) return [0, 0, 0, 0, 0]; // Avoid division by zero

  const counts = [5, 4, 3, 2, 1].map(star => {
    // Count how many reviews match this exact star rating
    const count = reviews.filter(r => Math.round(r.stars) === star).length;
    // Return the percentage
    return Math.round((count / total) * 100);
  });

  return counts;
};

const distributions = getDistribution(supabaseReviews);

const isNoFollow = currentItem?.IsNofollow === true || currentItem?.IsNofollow === 'true';
const isNoIndex = currentItem?.IsNoindex === true || currentItem?.IsNoindex === 'true' || currentItem?.IsNoindex === 'TRUE';

// 2. Determine the Robots string based on priority
let robotsContent = "index, follow"; // Default

if (isNoIndex) {
  robotsContent = "noindex, nofollow"; 
} else if (isNoFollow) {
  robotsContent = "index, nofollow";
}


const formattedManifestScore = trustscore 
  ? Number(trustscore).toFixed(1) 
  : "0.0";

  const cleanReviewCount = reviews
  ? parseInt(reviews, 10) 
  : 0;


  if (error === "Company not found") {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <Helmet>
        <title>Company Not Found | Sitemanifest</title>
        <meta name="robots" content={robotsContent}/>
      </Helmet>
      
      <h1 className="text-[40px] font-staat text-[#323232]">404</h1>
      <p className="font-poppins text-[#666] mb-8">This company hasn't been added to the Site yet.</p>
      
      <button 
        onClick={() => ''}
        className="bg-[#08696D] text-white px-8 py-3 rounded font-staat hover:bg-[#065659] transition-all"
      >
        Return to Directory
      </button>
    </div>
  );
}

  return (
   <>
{cleanReviewCount > 0 && stableCategory && !isNoIndex && !isNoFollow &&(
  <ReviewSchema 
    businessName={title}
    trustScore={formattedManifestScore}
    reviewCount={cleanReviewCount}
    reviews={supabaseReviews}
    logoUrl={allItemsData[0]?.img}
    category={stableCategory} 
    phone={phone}
    address={address3}
    postalCode={address4}
    city={address1}
    countryCode={country}
    domain={www || window.location.hostname.replace(/^www\./, '')}
  />
)}

<Helmet>
  <title>
    {error === "Company not found" 
      ? "Company Not Found | Sitemanifest" 
      : `${title || 'Business Profile'} | Verified Reviews | Sitemanifest`}
  </title>

  {/* 2. STRATEGIC INDEXING - This is the most important part */}
  {error === "Company not found" ? (
    /* Hide the page if it's a dead link */
    <meta name="robots" content="noindex, nofollow" />
  ) : (
    /* Only index if there is real content (reviews) */
    <meta 
      name="robots" 
      content={cleanReviewCount > 0 ? "index, follow" : "noindex, follow"} 
    />
  )}
{/* Add this inside your <Helmet> to force the specific description */}
<meta name="googlebot" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
  <meta 
    name="description" 
    content={error === "Company not found"
      ? "The requested business profile could not be found in the Sitemanifest directory."
      : cleanReviewCount > 0 
        ? `${cleanReviewCount} verified reviews for ${title}. Every interaction is authenticated through the Sitemanifest identity-first protocol.`
        : `Check out ${title} on Sitemanifest. Identity-first verification for honest business interactions.`
    } 
  />

  {/* 4. OPEN GRAPH - Previews for LinkedIn/WhatsApp */}
  <meta property="og:title" content={`${title || 'Business Profile'} | Verified by Sitemanifest`} />
  <meta property="og:description" content={cleanReviewCount > 0 ? `${cleanReviewCount} Verified Reviews.` : "Authentication-first business reviews."} />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={`https://sitemanifest.com/company/${www}`} />


  {!error && <link rel="canonical" href={`https://sitemanifest.com/company/${www}`} />}
</Helmet>


  <div className='flex flex-col h-full w-full bg-[#f9f9f9] pb-[100px] xs:items-center'>

    {(isReviewLoading || !currentItem) && <FullPageLoader />}

    {/* REVIEW MODAL: Using <aside> for non-main content overlay */}
    {isTestimonialWindowOpen && (
      <aside 
        aria-modal="true" 
        role="dialog" 
        className='flex flex-col xs:max-w-[700px] xs:rounded-[6px] xs:border xs:border-[#F2F2F2] xs:mt-[95px] xs:mx-auto w-full h-auto bg-white absolute z-20 xs:p-[32px] p-[16px]'
      >
        <form onSubmit={handleSubmit}>
          <div className='flex flex-row justify-between items-center'>
            <div className='flex gap-[4.7px] xs:gap-[5.7px]' aria-label={`Rating: ${actualRating} stars`}>
              {[1, 2, 3, 4, 5].map((index) => (
                <div key={`win-star-${index}`}>
                  <Star 
                    bgColor={getWindowStarColor(index)} 
                    boxheight={'h-[32px] xs:h-[55px]'} 
                    boxwidth={'w-[32px] xs:w-[55px]'} 
                    width={'w-[18px] xs:w-[30px]'}
                  />
                </div>
              ))}
            </div>
            <button type="button" onClick={() => setIsTestimonialWindowOpen(false)}>
               <img className='w-[32px] cursor-pointer' src={finalcancel} alt="Close Review Window" />
            </button>
          </div>
          
          <div className='flex flex-col gap-[24px] xs:gap-[32px] mt-[24px] xs:mt-[32px]'>
            <div className='flex flex-col gap-[10px]'>
              <label htmlFor="title-input" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Testimonial Title</label>
              <input 
                id="title-input"
                type="text" 
                value={content}
                onChange={(e) => SetContent(e.target.value)}
                placeholder="Quick and trustworthy"
                className='w-full min-h-[45px] outline-none border border-[#F6F6F6] rounded-[4px] p-3' 
              />
            </div>
                
            <div className='flex flex-col gap-[10px]'>
              <label htmlFor="review-textarea" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Tell us more about your experience</label>
              <textarea 
                id="review-textarea"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="They authenticated my item in just 2 days. Excellent communication and service."
                className='w-full min-h-[105px] border outline-none border-[#F6F6F6] rounded-[4px] p-3' 
                rows={4}
              />
            </div>

            <div className='flex flex-col gap-[10px] mt-4 p-4 bg-[#fcfcfc] border border-dashed border-[#e0e0e0] rounded-[4px]'>
              <div className='flex flex-col gap-[4px]'>
                <label htmlFor="intel-input" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>
                  Private Intel for the Owner <span className='text-[13px] text-gray-400'>(Optional)</span>
                </label>
                <p className='text-[12px] text-gray-500 font-noto'>
                  This note is sent directly to management and is never shown publicly.
                </p>
              </div>
              <textarea 
                id="intel-input"
                value={privateNoteText}
                onChange={(e) => setprivateNoteText(e.target.value)}
                placeholder="Is there something the manager should know or fix?"
                className='w-full min-h-[90px] outline-none border border-[#F6F6F6] rounded-[4px] p-3' 
                rows={3}
              />
            </div>

            <div className='flex flex-col gap-[10px]'>
              <label htmlFor="date-input" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Date of Experience</label>
              <input 
                id="date-input"
                type="date" 
                value={dateOfExperience}
                min={yearAgoStr}
                max={todayStr}
                onChange={(e) => setDateOfExperience(e.target.value)}
                className="w-full min-h-[45px] border border-[#F6F6F6] rounded-[4px] p-3"
              />
            </div>

            <div className='flex flex-col xs:flex-row xs:justify-between '>
              <div className='flex flex-col gap-[10px]'>
                <div className='flex flex-row gap-[15px] items-center'>
                  <span className='font-noto font-regular text-[#1a1a1a] text-[16px]'>
                    Proof of service <span className='text-red-500 font-bold'>*</span>
                  </span>
                  <img src={finalinfo} alt="Verification info" /> 
                  <span className='font-noto font-regular text-[#1a1a1a] text-[14px] text-gray-400'>(Mandatory for Verification)</span>
                </div>

                <label htmlFor="proof-upload" className='cursor-pointer'>
                  <div className='w-[175px] h-[105px] flex flex-col items-center justify-center bg-white border border-[#F6F6F6] hover:border-[#56AB75] transition-colors rounded-[4px] overflow-hidden'>
                    {file ? (
                      <div className='flex flex-col items-center gap-1 p-2'>
                        <span className='text-[10px] text-[#56AB75] font-bold uppercase'>File Loaded</span>
                        <span className='text-[11px] text-center truncate w-[150px]'>{file.name}</span>
                        <span className='text-[9px] text-gray-400'>Click to change</span>
                      </div>
                    ) : (
                      <img src={finalfile} alt="Click to upload proof of service" /> 
                    )}
                  </div>
                </label>
                <input 
                  id="proof-upload"
                  type="file" 
                  className='hidden'
                  accept="image/*,application/pdf"
                  onChange={(e) => {
                    const selectedFile = e.target.files[0];
                    if (selectedFile) setFile(selectedFile);
                  }} 
                />
              </div>

              <button 
                type="submit"
                className='w-[256px] xs:mt-auto xs:mx-0 h-[50px] rounded-[5px] bg-[#56AB75] text-[18px] font-noto font-medium text-white mt-[32px] mx-auto block'
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Testimonial'}
              </button>
            </div>
          </div>
        </form> 
        <p className='font-noto text-[10px] font-regular text-[#1a1a1a] text-center mt-[32px]'>By submitting this review, you confirm it’s based on a genuine experience.</p>
      </aside>
    )}

    {/* HEADER SECTION - Same UI as Batch 1 */}
    <header className={`flex-col flex w-full bg-white pt-[70px] xl:pt-[70px] mtb:px-0 ${isTestimonialWindowOpen ? "opacity-20" : "opacity-100"}`}>
      <div className='w-full xs:mt-0 lg:mt-[30px] xl:mt-[20px] py-[10px] mtb:px-0 xl:px-[64px] xs:px-[32px] 2xl:max-w-[1440px] 2xl:mt-[20px] 2xl:m-auto'>
        <div className='flex xs:mt-[20px] lg:mt-[40px] lg:pl-[12px] xl:pl-0 justify-around xs:items-start z-10 xs:justify-start flex-row w-full mt-[10px] gap-[15px] xs:gap-[32px] ip:gap-[18px] lg:px-0 lg:gap-[84px] xl:gap-[96px] 2xl:gap-[128px] px-[12px] pb-[25px]'>
          <div className='w-[80px]  h-[80px] select-none flex items-center justify-center ip:w-[100px] ip:h-[100px] xs:w-[120px] xs:h-[120px] lg:w-[140px] lg:h-[140px] xl:w-[200px] xl:h-[150px] mt-[7px]'>
            {allItemsData[0]?.img ? (
              <LazyLoadImage 
                src={allItemsData[0].img} 
                alt={`${title} business logo`} 
                effect="blur"
                onError={(e) => { e.target.src = defaultbusinessimg; }}
                className="w-auto xl:max-w-[180px] lg:ml-[15px] h-auto object-cover xs:max-w-[120px] lg:max-w-[175px] ip:max-w-[100px] max-w-[80px] xl:max-h-[180px]" 
              />
            ) : (
              <div className='w-full flex items-center justify-center h-full bg-gray-300'>
                <span className='uppercase font-poppins font-regular text-[42px]'>{title ? title[0] : '?'}</span>
              </div>
            )}
          </div>
<div className='w-full max-w-[143px] shadow-sm bg-gray-100 rounded-[6px] ip:max-w-[253px] xs:max-w-[220px] 2xl:max-w-[320px] lg:max-w-[291px] relative z-15 -rotate-[3deg] lg:-top-[15px] ip:top-[3px] min-h-[70px] ip:min-h-[100px] xs:min-h-[125px] lg:min-h-[185px]'>
  <div className='absolute ip:left-[5px] shadow-sm ip:-top-[4px] inset-0 rounded-[12px] rotate-[3deg] translate-x-[4px] translate-y-[6px] overflow-hidden bg-white p-[2px] z-20'>
    <div className='absolute inset-[-100%] animate-spin-slow' style={{ background: 'conic-gradient(from 0deg, transparent 70%, #3EBAA2)' }} />
    
    <div className='relative flex flex-col justify-start w-full h-full bg-white rounded-[10px] z-30 py-[6px] px-[10px] ip:py-[12px] ip:px-[14px] lg:py-[18px] lg:px-[22px] gap-y-1 lg:gap-y-3'>
      
      <h1 className='text-[10px] ip:text-[12px] lg:text-[16px] xl:text-[18px] font-poppins text-[#1a1a1a] font-semibold break-words line-clamp-12 leading-[1.1]'>
        {title}
      </h1>

  <div className='flex flex-row flex-wrap gap-[2px] lg:gap-[4px] items-center'>
  {Array(5).fill().map((_, i) => {
    const starValue = customRound(supabaseOnlyRating);
    
    // Logic: 
    // 1. Full Star: Index is less than the floor of the rating
    // 2. Half Star: Index matches the floor, and remainder is >= 0.5
    const isFull = i < Math.floor(starValue);
    const isHalf = i === Math.floor(starValue) && (starValue % 1) >= 0.5;
    
    return (
      <Star 
        key={i} 
        boxwidth={'w-[12px] ip:w-[15px] lg:w-[26px] xl:w-[30px]'} 
        boxheight={'h-[12px] ip:h-[15px] lg:h-[26px] xl:h-[30px]'} 
        width={'w-[9px] ip:w-[11px] lg:w-[16px] xl:w-[17px]'} 
        
        bgColor={isFull ? getStarColor(starValue) : 'bg-gray-300'} 
        half={isHalf} 
        halfStar={getStarColor(starValue)} 
      />
    );
  })}
</div>

      {/* TIGHTENED FOOTER: mt-0 instead of mt-auto on small screens to stop the 'push' */}
      <div className='flex mt-[15px] pt-1  flex-row items-center justify-between  ip:mt-auto sp:pt-1 ip:pt-2 border-t border-gray-50'>
        <div>
          {/* Label size reduced for smallest screens */}
          <p className='text-[6px] ip:text-[8px] lg:text-[10px] uppercase tracking-wider text-gray-400 font-bold leading-none'>Manifestscore</p>
          <p className='text-[9px] ip:text-[11px] mt-[5px] lg:text-[16px] font-poppins font-bold text-[#3EBAA2] leading-none'>{trustscore ? Number(trustscore).toFixed(1) : "0.0"}</p>
        </div>
        <div className='flex flex-col gap-[1px] items-end'>
          <p className='text-[6px] ip:text-[8px] lg:text-[10px] uppercase tracking-wider text-gray-400 font-bold leading-none'>{selectedLanguage === "english" ? 'Reviews' : 'Revues'}</p>
          <p className='text-[9px] ip:text-[11px] mt-[5px] lg:text-[16px] font-poppins font-semibold text-[#3EBAA2] leading-none'>{supabaseReviews.length > 0 ? reviews : fullReviews}</p>
        </div>
      </div>
    </div>
  </div>
</div>

          <div className='hidden xs:flex flex-col items-center  lg:min-h-[180px] lg:justify-between w-[350px] xl:w-[400px] xl:relative xl:-top-[20px] min-h-[100px] lg:mr-[120px] ml-auto'>
            <div className='max-w-[450px] font-noto text-[20px] lg:text-[28px] xl:text-[32px] text-[#1a1a1a] text-center'>How would you rate <span className='text-[#3EBAA2] block'>{title} ?</span></div>
            <div className='flex gap-[8px] xl:gap-[12px] mt-[20px]'>
              {starIndexes.map((index) => (
                <div key={index} onClick={() => handleStarClick(index)} onMouseEnter={() => setHoverRating(index)} onMouseLeave={() => setHoverRating(0)} className='cursor-pointer'>
                  <Star bgColor={getTestimonialStarColorz(index)} boxheight={'h-[48px] xl:h-[60px]'} boxwidth={'w-[48px] xl:w-[60px]'} width={'w-[28px] xl:w-[35px]'} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>

    {/* MAIN CONTENT AREA */}
    <main className={`w-full ${isTestimonialWindowOpen ? "opacity-20" : "opacity-100"}`}>
      
      {/* MOBILE CTA */}
      <section aria-label="Review Interaction" className='flex flex-col items-center xs:hidden w-full h-[150px] bg-white'>
        <div className='w-[193px] mx-auto text-center'>
          <h2 className='font-noto text-[20px] font-regular leading-[32px] text-[#1a1a1a]'>How would you rate <span className='text-[#3EBAA2]'>{title} ?</span></h2>
        </div>
        <div className='flex gap-[6px] xl:gap-[12px] mt-[20px]'>
          {starIndexes.map((index) => (
            <div key={index} onClick={() => handleStarClick(index)} onMouseEnter={() => setHoverRating(index)} onMouseLeave={() => setHoverRating(0)} className='cursor-pointer'>
              <Star bgColor={getTestimonialStarColorz(index)} boxheight={'h-[40px] xl:h-[60px]'} boxwidth={'w-[40px] xl:w-[60px]'} width={'w-[22px] xl:w-[35px]'} />
            </div>
          ))}
        </div>
      </section>

      {/* MOBILE SIDEBAR (Visible only on mobile) */}
      <section className='mt-10  mb-6 px-4 w-full max-w-[420px] mx-auto lg:hidden xl:hidden'>
        <div className="relative bg-white/70 backdrop-blur-md rounded-[32px] p-6 pb-20 border border-white shadow-sm">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
            <h2 className="text-[10px] font-bold uppercase tracking-widest text-slate-400">About {title}</h2>
          </div>
          <p className='text-[13px] leading-relaxed font-poppins text-slate-600'>{about}</p>
        </div>
        <div className="relative -mt-14 z-10 flex flex-col gap-2">
          <div className="bg-[#1a1a1a] rounded-[24px] p-4 shadow-xl flex items-center justify-between">
            <div className="flex items-center gap-3 w-full">
              <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
                <img className='w-5 invert' src={finalemail} aria-hidden="true" alt="" />
              </div>
              <div className="flex flex-col min-w-0 ">
                <span className="text-[13px] font-semibold text-white font-poppins truncate">{email}</span>
                <span className="text-[10px] text-indigo-300 uppercase font-bold tracking-tighter">Official Channel</span>
              </div>
            </div>
          </div>
          <div   onClick={() => {
      const destination = www.startsWith('http') ? www : `https://${www}`;
      window.open(destination, '_blank', 'noopener,noreferrer');
    }}  className="bg-white rounded-[24px] p-4 border border-slate-100 flex items-center gap-3">
            <img className='w-4 mt-[2px]' aria-hidden="true" src={globeimg} alt="" />
            <span className="text-[13px] font-bold text-slate-800">{www}</span>
          </div>
          <div className="bg-white rounded-[24px] p-4 border border-slate-100 flex items-center gap-3">
            <img className='w-4' aria-hidden="true" src={finalphone} alt="" />
            <span className="text-[13px] font-bold text-slate-800">{phone}</span>
          </div>
          <div className="bg-white rounded-[24px] p-4 border border-slate-100 flex items-center gap-3">
            <img className='w-4' aria-hidden="true" src={finallocation}  alt="" />
            <span className="text-[13px] font-bold text-slate-800">{country}</span>
          </div>
        </div>


     <div className='mt-[30px] max-w-[548px] ml-auto lg:flex flex-col w-full mb-14 px-4'>
  {/* Header Section */}
  <div className="flex flex-col gap-1 mb-5">
    <h4 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#3EBAA2]">Filter by</h4>
    <h2 className="text-[20px] font-light text-[#1a1a1a] font-poppins">Stars</h2>
  </div>

  {/* Filter List */}
  <div className='relative flex flex-col gap-8 w-full pl-6' role="navigation" aria-label="Review Filters">
    <div className="absolute left-0 top-2 bottom-2 w-[1px] bg-black/5" />
    
    {[5, 4, 3, 2, 1].map((star, index) => {
      // Pull the percentage from your 'distributions' array using the current index
      const percentage = distributions[index] || 0;
      const isSelected = selectedStarFilter === star;

      return (
        <button 
          key={star} 
          aria-pressed={isSelected} 
          aria-label={`Filter reviews by ${star} stars`} 
          onClick={() => setSelectedStarFilter(isSelected ? null : star)} 
          className="group relative flex items-center justify-between transition-all w-full"
        >
          {/* Timeline Dot */}
          <div className={`absolute -left-[27px] w-2 h-2 rounded-full border-2 border-[#f3f3f3] transition-all ${isSelected ? 'bg-[#3EBAA2] scale-150' : 'bg-slate-200 group-hover:bg-slate-300'}`} />
          
          <div className="flex items-center gap-3">
            <span className={`text-[15px] font-poppins transition-colors ${isSelected ? 'text-[#3EBAA2] font-bold' : 'text-slate-400 group-hover:text-slate-600'}`}>
              {star} Stars
            </span>
            {/* Selection Line */}
            <div className={`h-[1px] transition-all duration-500 ${isSelected ? 'w-12 bg-[#3EBAA2]' : 'w-0 bg-transparent'}`} />
          </div>

          <div className="flex flex-col items-end min-w-[60px]">
            <span className={`text-[13px] font-poppins tabular-nums transition-colors ${isSelected ? 'text-[#3EBAA2] font-bold' : 'text-slate-300'}`}>
              {percentage}%
            </span>
            {/* Visual Progress Bar */}
            <div className="w-16 h-[3px] bg-black/5 rounded-full mt-1 overflow-hidden">
              <div 
                className={`h-full transition-all duration-700 ease-out ${isSelected ? 'bg-[#3EBAA2]' : 'bg-slate-200'}`} 
                style={{ width: `${percentage}%` }} 
              />
            </div>
          </div>
        </button>
      );
    })}
  </div>
</div>
      </section>

      


      {/* REVIEWS GRID AREA */}
      <div className='mt-[20px] xl:mt-[25px] w-full 2xl:max-w-[1440px] lg:px-[32px] xl:px-[64px] 2xl:mx-auto flex flex-col gap-[30px] lg:items-end lg:w-full ip:px-[20px]'>
        <div className='flex flex-row w-full lg:gap-[32px] xl:gap-[64px] mt-[15px]'>
          
          {/* LEFT: REVIEW LIST */}
      {/* LEFT: REVIEW LIST */}
<section className="flex  flex-col gap-0 lg:gap-[10px] lg:items-end w-full flex-grow xl:pl-[100px]">
   {currentReviews.map((review, index) => (
     <article key={review.id} ref={index === 0 ? firstReviewRef : null}>
       <CustomerReview 
         {...review} 
         businessimg={img} 
         ReplierCompany={title} 
         session={session} 
       />
     </article>
   ))}
   
   {/* OPTIMIZATION: Show a message if no reviews match the filter */}
   {currentReviews.length === 0 && (
     <div className="w-full text-center py-20 font-poppins text-gray-400">
       No {selectedStarFilter}-star reviews found for this business.
     </div>
   )}
</section>
          {/* RIGHT: DESKTOP SIDEBAR (Visible only on desktop) */}
          <aside className='lg:flex  lg:max-w-[460px] xl:max-w-[778px] lg:ml-auto flex-col hidden xl:w-[750px]'>
            
            {/* Filter by Stars */}
       <div className='hidden lg:flex max-w-[548px] ml-auto lg:flex flex-col w-full mb-14 px-4'>
  {/* Header Section */}
  <div className="flex flex-col gap-1 mb-5">
    <h4 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#3EBAA2]">Filter by</h4>
    <h2 className="text-[20px] font-light text-[#1a1a1a] font-poppins">Stars</h2>
  </div>

  {/* Filter List */}
  <div className='relative flex flex-col gap-8 w-full pl-6' role="navigation" aria-label="Review Filters">
    <div className="absolute left-0 top-2 bottom-2 w-[1px] bg-black/5" />
    
    {[5, 4, 3, 2, 1].map((star, index) => {
      // Pull the percentage from your 'distributions' array using the current index
      const percentage = distributions[index] || 0;
      const isSelected = selectedStarFilter === star;

      return (
        <button 
          key={star} 
          aria-pressed={isSelected} 
          aria-label={`Filter reviews by ${star} stars`} 
          onClick={() => setSelectedStarFilter(isSelected ? null : star)} 
          className="group relative flex items-center justify-between transition-all w-full"
        >
          {/* Timeline Dot */}
          <div className={`absolute -left-[27px] w-2 h-2 rounded-full border-2 border-[#f3f3f3] transition-all ${isSelected ? 'bg-[#3EBAA2] scale-150' : 'bg-slate-200 group-hover:bg-slate-300'}`} />
          
          <div className="flex items-center gap-3">
            <span className={`text-[15px] font-poppins transition-colors ${isSelected ? 'text-[#3EBAA2] font-bold' : 'text-slate-400 group-hover:text-slate-600'}`}>
              {star} Stars
            </span>
            {/* Selection Line */}
            <div className={`h-[1px] transition-all duration-500 ${isSelected ? 'w-12 bg-[#3EBAA2]' : 'w-0 bg-transparent'}`} />
          </div>

          <div className="flex flex-col items-end min-w-[60px]">
            <span className={`text-[13px] font-poppins tabular-nums transition-colors ${isSelected ? 'text-[#3EBAA2] font-bold' : 'text-slate-300'}`}>
              {percentage}%
            </span>
            {/* Visual Progress Bar */}
            <div className="w-16 h-[3px] bg-black/5 rounded-full mt-1 overflow-hidden">
              <div 
                className={`h-full transition-all duration-700 ease-out ${isSelected ? 'bg-[#3EBAA2]' : 'bg-slate-200'}`} 
                style={{ width: `${percentage}%` }} 
              />
            </div>
          </div>
        </button>
      );
    })}
  </div>
</div>

            {/* About Leaf */}
            <div className='hidden lg:flex ml-auto flex-col w-full xl:max-w-[550px] lg:max-w-[450px] sticky top-12 pb-10'>
              {about && (
                <div className="relative bg-white/50 backdrop-blur-2xl rounded-[40px] p-10 pb-28 border border-white/80 shadow-sm -rotate-2 origin-bottom-right">
                  <h2 className="text-[12px] font-black uppercase tracking-[0.25em] text-slate-400 mb-5 rotate-2">About {title}</h2>
                  <p className='text-[16px] xl:text-[18px] leading-[1.8] font-poppins text-slate-700 rotate-2 font-medium italic'>{about}</p>
                </div>
              )}
              <div className="relative z-20 flex flex-col gap-5 px-6">
                {email && (
                  <div className="bg-[#1a1a1a] rounded-[32px] p-8 shadow-2xl hover:-translate-y-2 transition-transform">
                    <div className="flex items-center gap-6">
                      <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center border border-white/10"><img aria-hidden="true" className='w-7 invert' src={finalemail} alt="" /></div>
                      <div className="flex flex-col">
                        <span className="text-[11px] text-[#3EBAA2] uppercase font-black">Official Inquiry</span>
                        <span className="text-[16px] xl:text-[19px] font-bold text-white font-poppins truncate max-w-full">{email}</span>
                      </div>
                    </div>
                  </div>
                )}
{www && (
  <div 
    onClick={() => {
      // Ensure the URL starts with http or https
      const destination = www.startsWith('http') ? www : `https://${www}`;
      window.open(destination, '_blank', 'noopener,noreferrer');
    }} 
    className="bg-white cursor-pointer rounded-[28px] py-5 px-8 border border-slate-100 shadow-xl flex items-center gap-5 hover:translate-x-3 transition-transform group"
  >
    <img className='w-5 mt-[2px] opacity-70 group-hover:rotate-12 transition-transform' aria-hidden="true" src={globeimg} alt="" />
    <span className="text-[16px] font-bold text-slate-900 font-poppins">{www}</span>
    
    {/* Minimalist Arrow to signal "leaving the site" */}
    <svg className="w-4 h-4 ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
    </svg>
  </div>
)}
                {phone && (
                  <div className="bg-white rounded-[28px] py-5 px-8 border border-slate-100 shadow-xl flex items-center gap-5 hover:translate-x-3 transition-transform">
                    <img className='w-5 opacity-70' aria-hidden="true" src={finalphone} alt="" />
                    <span className="text-[16px] font-bold text-slate-900 font-poppins">{phone}</span>
                  </div>
                )}
                {address && (
                  <div className="bg-white rounded-[35px] p-8 border border-slate-100 shadow-xl flex items-start gap-5 hover:translate-x-3 transition-transform">
                    <img className='w-6 opacity-70 mt-1' aria-hidden="true" src={finallocation} alt="" />
                    <div className="flex flex-col gap-1">
                      <span className="text-[11px] text-slate-400 uppercase font-black">Location</span>
                      <span className="text-[16px] font-bold text-slate-900 font-poppins">{country}</span>
                      <span className="text-[16px] font-bold text-slate-900 font-poppins">{address1}</span>
                      <span className="text-[16px] font-bold text-slate-900 font-poppins">{address3}</span>
                      <span className="text-[16px] font-bold text-slate-900 font-poppins">{address4}</span>
                      {/* <span className="text-[15px] text-slate-600 font-medium font-poppins">{address2 }</span> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </aside>
        </div>
      </div>
      {totalPages > 1 && (
<nav aria-label="Pagination" className="flex w-full items-center justify-center mt-12 mb-6">
  <div className="flex items-center gap-2 sp:gap-3">
    
    {/* PREV */}
    <button 
      onClick={handlePrevPage} 
      disabled={currentPage === 1}
      className={`px-3 py-2 rounded-xl border transition-all font-spartan text-[12px] font-bold uppercase
        ${currentPage === 1 ? 'border-slate-100 text-slate-300' : 'border-slate-200 text-slate-600 hover:border-black'}`}
    >
      Prev
    </button>

    {/* SMART PAGES */}
    <div className="flex items-center gap-1">
      {smartPages.map((num, index) => {
        const isActive = num === currentPage;
        const isDots = num === '...';

        return (
          <button 
            key={index} 
            disabled={isDots}
            onClick={() => !isDots && handlePageChange(num)}
            className={`w-9 h-9 flex items-center justify-center rounded-xl font-spartan text-[14px] font-bold transition-all
              ${isActive 
                ? 'bg-slate-900 text-white shadow-lg' 
                : isDots 
                  ? 'text-slate-300 cursor-default' 
                  : 'text-slate-500 hover:bg-slate-100'}`}
          >
            {num}
          </button>
        );
      })}
    </div>

    {/* NEXT */}
    <button 
      onClick={handleNextPage} 
      disabled={currentPage === totalPages}
      className={`px-3 py-2 rounded-xl border transition-all font-spartan text-[12px] font-bold uppercase
        ${currentPage === totalPages ? 'border-slate-100 text-slate-300' : 'border-slate-200 text-slate-600 hover:border-black'}`}
    >
      Next
    </button>
    
  </div>
</nav>
      )}
    </main>


    {/* Floating Toast Notification */}
{toast.message && (
  <div className={`fixed top-10 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-xl shadow-2xl z-[9999] font-jakarta text-[14px] font-bold tracking-tight flex items-center gap-3 animate-slide-down border
    ${toast.type === 'error' ? 'bg-white border-red-100 text-red-600' : 'bg-[#25c673] border-emerald-400 text-white'}`}>
    <div className={`w-2 h-2 rounded-full animate-pulse ${toast.type === 'error' ? 'bg-red-500' : 'bg-white'}`}></div>
    {toast.message}
  </div>
)}

{/* Minimalist CSS */}
<style>{`
  @keyframes slide-down {
    0% { transform: translate(-50%, -20px); opacity: 0; }
    100% { transform: translate(-50%, 0); opacity: 1; }
  }
  .animate-slide-down {
    animation: slide-down 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
`}</style>
  </div>
  
</>
  );
}


